import { ApiClient } from '@provider-portal/common/api';

import { CredentialsSessionEpicDependencies } from '@bolteu/redux-session';

import { getDeviceInfo, getDeviceUniqueId } from 'utils/deviceInfo';
import { ErrorReporter } from '@provider-portal/common/utils/errorReporting';

export interface CredentialsWithMagicLink {
  username?: string;
  password?: string;
  token?: string;
}

export const createCredentialsSessionEpicDependencies = (
  apiClient: ApiClient,
): CredentialsSessionEpicDependencies => {
  return <CredentialsSessionEpicDependencies>{
    api: {
      getRefreshToken: async (credentials: CredentialsWithMagicLink) => {
        const deviceInfo = {
          device_name: getDeviceInfo().browser.name || 'unknown',
          device_os_version: getDeviceInfo().os.version?.toString() || 'unknown',
          device_uid: getDeviceUniqueId(),
        };
        if (credentials.username && credentials.password) {
          try {
            return apiClient.deliveryProviderAuthNoAuth.publicAuthenticate({
              username: credentials.username,
              password: credentials.password,
              ...deviceInfo,
            });
          } catch (errAuth) {
            ErrorReporter.captureException(errAuth);
            return errAuth;
          }
        }
        if (credentials.token) {
          try {
            return apiClient.deliveryProviderAuthNoAuth.publicAuthenticateWithMagicLink({
              token: credentials.token,
              ...deviceInfo,
            });
          } catch (errAuthMagicLink) {
            ErrorReporter.captureException(errAuthMagicLink);
            return errAuthMagicLink;
          }
        }

        return null;
      },
      getAccessToken: ({ refresh_token }) =>
        apiClient.deliveryProviderAuthNoAuth.publicGetAccessToken({ refresh_token }),
      logout: ({ refresh_token }) =>
        apiClient.deliveryProviderAuth.logout({ refresh_token }).catch((e) => {
          ErrorReporter.captureException(e);
          throw e;
        }),
    },
  };
};
